import Qs from "qs";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

/**
 * Add multiple parameters to the URL
 * @returns Function to add multiple parameters.
 */
export const useToggleUrlParameters = () => {
    const { push } = useHistory();

    const toggleUrlParamers = useCallback(
        (parameters: { [index: string]: any }) => {
            const currentParameters = Qs.parse(window.location.search, { ignoreQueryPrefix: true });

            // All parameters have the same values as those in URL location search
            const allHaveSameValues = Object.entries(parameters).every(
                ([searchEntryKey]) => parameters[searchEntryKey] === String(currentParameters[searchEntryKey])
            );

            let updatedParameters;
            // When the values are the same, remove the parameters
            if (allHaveSameValues) {
                updatedParameters = Object.fromEntries(
                    Object.entries(currentParameters).filter(
                        ([searchEntryKey]) => !Object.keys(parameters).includes(searchEntryKey)
                    )
                );
            } else {
                updatedParameters = { ...currentParameters, ...parameters };
            }
            push({ search: Qs.stringify(updatedParameters, { addQueryPrefix: true, arrayFormat: "repeat" }) });
        },
        [push]
    );

    return toggleUrlParamers;
};
